"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = dispatchCartCountUpdated;
var _customEventNames = require("@nike/custom-event-names");
var _createCustomEvent = _interopRequireDefault(require("../../../../../utils/create-custom-event"));
var _dispatchCustomEvent = _interopRequireDefault(require("../../../../../utils/dispatch-custom-event"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Dispatches the cartCountUpdated custom event to notify consumers
 * that the cart count has changed after an add or remove item operation.
 * This event is used by the global nav and other UI components to update
 * the cart icon badge count.
 *
 * @param {number} cartCount - The new cart count (totals.quantity from cart data)
 */
function dispatchCartCountUpdated(cartCount) {
  var cartCountEvent = (0, _createCustomEvent["default"])(_customEventNames.CART_COUNT_UPDATED_EVENT_NAME, {
    bubbles: true,
    detail: {
      cartCount: cartCount
    }
  });
  (0, _dispatchCustomEvent["default"])(cartCountEvent);
}